const TOKEN = 'GTSYS-TOKEN';
export default {
    key: TOKEN,
    
    get() {
        return sessionStorage.getItem(TOKEN);
    },

    getHeader() {
        let token = sessionStorage.getItem(TOKEN);
        return {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
    },

    remove() {
        if (sessionStorage.getItem(TOKEN)) {
            sessionStorage.removeItem(TOKEN);
        }
    },

    set(token) {
        if (sessionStorage.getItem(TOKEN)) {
            sessionStorage.removeItem(TOKEN);
        }
        sessionStorage.setItem(TOKEN, token);
    }
}